import React from 'react';

import * as z from 'zod';

export * from './EnvironmentProvider';

export * from './context';

export enum Environments {
	LOCAL,
	STAGING,
	PRODUCTION,
}

export const zEnvironment = z.object({
	version: z.string(),
	isLoading: z.boolean(),
	environment: z.nativeEnum(Environments),
	environmentString: z.string(),
	client: z.object({
		url: z.string(),
	}),
	api: z.object({
		url: z.string(),
		wsUrl: z.string(),
		version: z.string(),
	}),
	analytics: z.object({
		url: z.string(),
		websiteId: z.string(),
		debug: z.boolean(),
	}),
	mediaDomainRoot: z.string(),
	integrations: z.object({
		chargebee: z.object({
			domain: z.string(),
			planId: z.string(),
		}),
		analytics: z.object({
			measurementId: z.string(),
			enabled: z.boolean(),
		}),
		intercom: z.object({
			appId: z.string(),
		}),
		onesignal: z.object({
			appId: z.string(),
		}),
	}),
});

export type Environment = z.infer<typeof zEnvironment>;

export const ENV_DEFAULT_STRING = '';

export const defaultEnvironment: Environment = {
	version: ENV_DEFAULT_STRING,
	isLoading: true,
	environment: Environments.LOCAL,
	environmentString: ENV_DEFAULT_STRING,
	mediaDomainRoot: ENV_DEFAULT_STRING,
	client: {
		url: ENV_DEFAULT_STRING,
	},
	api: {
		url: ENV_DEFAULT_STRING,
		wsUrl: ENV_DEFAULT_STRING,
		version: ENV_DEFAULT_STRING,
	},
	analytics: {
		url: ENV_DEFAULT_STRING,
		websiteId: ENV_DEFAULT_STRING,
		debug: false,
	},
	integrations: {
		chargebee: {
			domain: ENV_DEFAULT_STRING,
			planId: ENV_DEFAULT_STRING,
		},
		analytics: {
			enabled: false,
			measurementId: ENV_DEFAULT_STRING,
		},
		intercom: {
			appId: ENV_DEFAULT_STRING,
		},
		onesignal: {
			appId: ENV_DEFAULT_STRING,
		},
	},
};

export const EnvironmentContext =
	React.createContext<Environment>(defaultEnvironment);
